const flipCard = document.getElementById('flipCard');
        let isFlipped = false;

        flipCard.addEventListener('click', function() {
            isFlipped = !isFlipped;
            if (isFlipped) {
                flipCard.classList.add('flipped');
            } else {
                flipCard.classList.remove('flipped');
            }
        });

        // Add keyboard support
        document.addEventListener('keydown', function(e) {
            if (e.code === 'Space' || e.code === 'Enter') {
                e.preventDefault();
                flipCard.click();
            }
        });

        // Optional: Add swipe gestures for mobile
        let touchStartX = null;
        
        flipCard.addEventListener('touchstart', function(e) {
            touchStartX = e.touches[0].clientX;
        });

        flipCard.addEventListener('touchend', function(e) {
            if (!touchStartX) return;
            
            const touchEndX = e.changedTouches[0].clientX;
            const diff = touchStartX - touchEndX;

            // If swipe is significant, flip the card
            if (Math.abs(diff) > 50) {
                flipCard.click();
            }
            
            touchStartX = null;
        });